import { c as _c } from "react/compiler-runtime";
import NextLink from 'next/link';
import { twMerge } from 'tailwind-merge';
type Props = {
  href: string;
  useStyle?: boolean;
} & React.ComponentPropsWithoutRef<typeof NextLink>;
export function Link(t0) {
  const $ = _c(12);
  let children;
  let className;
  let props;
  let useStyle;
  if ($[0] !== t0) {
    ({
      className,
      useStyle,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = useStyle;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    useStyle = $[4];
  }
  const t1 = useStyle ? "link" : "hover:text-red-800 dark:hover:text-red-700";
  let t2;
  if ($[5] !== className || $[6] !== t1) {
    t2 = twMerge("group underline-offset-4 transition-all duration-300 hover:underline", t1, className);
    $[5] = className;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== children || $[9] !== props || $[10] !== t2) {
    t3 = <NextLink hrefLang="en" scroll={true} className={t2} {...props}>{children}</NextLink>;
    $[8] = children;
    $[9] = props;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}